// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Grid, Button, Hidden, Dialog, DialogContent } from "@material-ui/core";
import { getLanguage } from "../../../../../Helpers/LanguageHelper";
import "./Segments.scss";
import blobLarge from "../../../../../assets/img/shapes/blobLarge.svg";
import blobMedium from "../../../../../assets/img/shapes/blobMedium.svg";
import blobMediumTwo from "../../../../../assets/img/shapes/blobMedium_2.svg";
import { NavLink } from "react-router-dom";
import { EventCaseKitchen } from "../cases/Kitchen";
import { FeaturePreview } from "../parts/FeaturePreview";
import { Footer } from "../../Navigation/Footer";
import { YouTubeEmbed } from "../../../../Parts/General/YouTubeEmbed";
interface IProps extends RouteComponentProps { }
interface IState {
  dialogOpen: boolean;
}
export class KitchensSegment extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      dialogOpen: false,
    }
  }
  render() {
    return (
      <div className="segmentPage">
        <div className="hero">
          <Hidden mdUp>
            <img
              className="heroImage_mobile"
              src="/img/photos/segment_kitchen_mobile.png"
              alt="Product image"
            />
          </Hidden>
          <div className="container">
            <Grid container>
              <Grid item md={6}>
                <h1 className="tagline">{getLanguage(499, "Staffing for professional kitchens.")}</h1>
                <p className="heroContent">
                  {getLanguage(500, "By using Chabber you're guaranteed kitchen freelancers 24/7. We are true to our word and provide you with an easy solution so you can avoid the typical agency trouble.")}
                </p>
                <div className="inputGroup">
                  <Button
                    className="button-gradient inputGroup_item"
                    variant="contained"
                    size="medium"
                    href="register"
                  >
                    <span className="btn-icon">
                      <i className="fas fa-arrow-right" />
                    </span>
                    {getLanguage(351, "Get started!")}
                  </Button>
                  <Button className="inputGroup_item" onClick={() => this.setState({ dialogOpen: true })}>
                    {getLanguage(352, "Watch video")}
                  </Button>
                </div>
              </Grid>
              <Grid item md={6}>
                <Hidden smDown>
                  <img
                    className="heroImage"
                    src="/img/photos/segment_kitchen@2x.png"
                    alt="Product image"
                  />
                </Hidden>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className="container">
          <section className="text-center">
            <Hidden smDown>
              <img className="blob blobMedium blobValue" src={blobMediumTwo} alt="svg blob" />
            </Hidden>
            <Grid container spacing={2} justify="space-evenly">
              <Grid item xs={12} sm={4}>
                <div className="valueProp">
                  <div className="valueProp_Icon">
                    <i className="far fa-clock fa-3x"></i>
                  </div>
                  <div className="valueProp_Title">{getLanguage(493, "Access 24/7")}</div>
                  <div className="valueProp_Content">
                    {getLanguage(494, "With a profile on Chabber you can book freelancer round the clock. You can do this through our website or app.")}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className="valueProp">
                  <div className="valueProp_Icon">
                    <i className="far fa-clock fa-3x"></i>
                  </div>
                  <div className="valueProp_Title">{getLanguage(495, "Guaranteed freelancers")}</div>
                  <div className="valueProp_Content">
                    {getLanguage(496, "Chabber community consists of thousands of freelancers, which is why we've always got people ready to help you out")}
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2} justify="space-evenly">
              <Grid item xs={12} sm={4}>
                <div className="valueProp">
                  <div className="valueProp_Icon">
                    <i className="far fa-clock fa-3x"></i>
                  </div>
                  <div className="valueProp_Title">{getLanguage(501, "You can count on us")}</div>
                  <div className="valueProp_Content">
                    {getLanguage(502, "We know it's hard to find the right kitchen staff. That's why we match your expectations and let you choose the best freelancer for the job.")}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className="valueProp">
                  <div className="valueProp_Icon">
                    <i className="far fa-clock fa-3x"></i>
                  </div>
                  <div className="valueProp_Title">{getLanguage(503, "Quick and easy")}</div>
                  <div className="valueProp_Content">
                    {getLanguage(504, "Staffing is often overly complicated and time consuming. With Chabber you can put in your order quick and easy and get on with your daily tasks.")}
                  </div>
                </div>
              </Grid>
            </Grid>
          </section>
          <section>
            <img className="blob blobLarge blobCase" src={blobLarge} alt="svg blob" />
            <div className="sectionHeading">{getLanguage(361, "This is what our customers say")}</div>
            <EventCaseKitchen />
          </section>
          <section>
            <Hidden smDown>
              <img className="blob blobMedium blobFeatures" src={blobMedium} alt="svg blob" />
            </Hidden>
            <FeaturePreview />
          </section>
        </div>
        <Footer />
        <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} fullWidth maxWidth="md">
          <DialogContent>
            <YouTubeEmbed videoID="_5h-E5ehq_8" />
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}